import e from"./placeholder.js";export{default}from"./placeholder.js";
